

import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';
import AddingModel from '../common/adding-model';

import {connect} from 'react-redux'
import {GetUserToken, PostToBackend} from "../../api/services";
import eConfig from '../../config';



class SettingDealerComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            List: [],
            Information:{},
            Current: null,
            modeList: true,
            modeUpdate:false,
            newEntry:{
                Ref :"",
                Email :"",
                Phone :"",
                Name :"",
                ContactPerson :"",
                ContactPhone :"",
                ContactAddress :"",
            }
        }

    }

    async componentDidMount() {
        await this.isSupperUser()
        await this.fetchDealers();
        await this.findInformation();

    }
    isSupperUser=async ()=>{
        let user = GetUserToken();
        const role = user.Role;
        if(role!=="super"){
            alert("Sorry you can't perform this action,Your role is: "+role+"");
            window.location.href="#/home"
        }
    }
    findInformation=async ()=>{
        let _this =this;
        const user  = GetUserToken();
        let hub = {
            RequesterUsername :user.Username,
            RequesterPhone    : user.Phone,
            RequesterRole     : user.Role,
        }
        //  /backend-ecare/api/global-service
        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-information/user";

        console.log("findInformation send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("findInformation response > ", dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                _this.setState({
                    Information:data
                })

            }
        });
    }
    fetchDealers = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("dealership", conds, (data) => {
            console.log("fetchCommissionStructure :> ", data);
            _this.setState({
                List: data,
            });
        });
    }
    fetchingAll = async (table, conds, callback) => {

        const user = GetUserToken();
        console.log("User :> ", user);

        let hub = {
            Fields: [],
            DbName: "chela",
            TableName: table,
            Conditions: conds,
        }
        //  /backend-ecare/api/global-service
        let backend = eConfig.mainBackend;
        let endpoint = "/api/global-service/list";

        console.log("fetchingAll send > ", table, hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchingAll response > ", table, dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                callback(data);

            }
        });
    }

    viewListDetail = (row) => {
        console.log("View List detail Dealer ", row);
        let o = {
            Ref :row.ref,
            Email :row.email,
            Phone :row.phone,
            Name :row.name,
            ContactPerson :row.contactperson,
            ContactPhone :row.contactphone,
            ContactAddress :row.contactaddress,
        }

        let tmp = this.state;
        tmp.newEntry = o;
        tmp.modeList = false;
        tmp.modeUpdate = true;
        this.setState(tmp);

    }
    closeView=()=>{
        let tmp = this.state;
        tmp.newEntry={
            Ref :"",
            Email :"",
            Phone :"",
            Name :"",
            ContactPerson :"",
            ContactPhone :"",
            ContactAddress :"",
        }

        tmp.modeList = true;
        tmp.modeUpdate = false;
        this.setState(tmp);
    }

    submitEntry=async ()=>{
        let _this = this;
        if(!window.confirm("Are you sure that you want to add this Dealer?")){
            return
        }
        //TODO validation here

        let hub={...this.state.newEntry};
        hub.Phone =hub.Ref;
        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-finance/manage/dealer/add";

        console.log("submitEntry send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("submitEntry response > ", dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                if(data !=="ADDED"){
                    alert(data)
                }else{
                    alert("Thank you dealer added!");
                    _this.closeView();
                    _this.fetchDealers();
                }


            }
        });

    }

    renderList = () => {

        if (!this.state.modeList) {
            return null
        }

        return this.state.List.map((row, index) => {
            return (<tr key={index}>
                <td>{row.ref}</td>
                <td>{row.name}</td>
                <td>{row.email}</td>
                <td>
                    <a
                        onClick={() => {
                            this.viewListDetail(row)
                        }}
                        style={{cursor: "pointer"}}
                    >View Detail</a>
                    &nbsp;&nbsp;|&nbsp;&nbsp;

                </td>
            </tr>)
        })

    }

    getNewEntryValue=(key)=>{
        return this.state.newEntry[key];
    }
    setNewEntryValue=(e,key)=>{
        let tmp=this.state;
        tmp.newEntry[key] = e.target.value;
        this.setState(tmp);
    }
    onClickChooseDealer=async(row)=>{
        const _this = this;
        console.log("onClickChooseDealer ==> ",row);
        const msg ="Are you sure that you want to upgrade this user \nFullname: "+row.Fullname+
            "\nRole: "+row.Role+"\nPhone: "+row.Phone+"\n"+
            "To the Dealer?";
        if(!window.confirm(msg)){
            return null
        }

        let hub={
            Ref :row.Phone,
            Email :row.Username,
            Phone :row.Phone,
            Name :row.Fullname,
            ContactPerson :row.Fullname,
            ContactPhone :row.Phone,
            ContactAddress :"",
        }

        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-finance/manage/dealer/add";

        console.log("submitEntry send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("submitEntry response > ", dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                if(data !=="ADDED"){
                    alert(data)
                }else{
                    alert("Thank you dealer added!");
                    _this.closeView();
                    _this.fetchDealers();
                }
            }
        });

    }
    newEntryForm=()=> {
        if (this.state.modeList) {
            return null
        }

        let lsUser = [];
        for (let i in this.state.Information.Users) {
            const row = this.state.Information.Users[i];
            lsUser.push(row);
        }

        const canBe = (boo) => {
            if (boo) {
                return "Yes"
            }
            return "No"
        }

        return (
            <div>
                <p className={"alert alert-info"}>Choose the user from the list to Upgrade</p>
                <table className={"table table-bordered"}>
                    <thead className="table-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Full Name</th>
                        <th scope="col">AccountRef</th>
                        <th scope="col">Role</th>
                        <th scope="col">Dealer</th>
                        <th scope="col">Wallet</th>
                        <th scope="col">QualifyToBeAgent</th>
                        <th scope="col">QualifyToBeDealer</th>
                        <th scope="col">Province</th>
                    </tr>
                    </thead>
                    <tbody>
                    {lsUser.map((row, index) => {
                        let boo = false;
                        let colorIn="success";
                        if (!row.QualifyDealer) {
                            boo = true;
                             colorIn="default";
                        }

                        if(row.Role==="agent"){
                            boo = true;
                            colorIn="default";
                        }

                        return (
                            <tr key={index}>
                                <td>
                                    <button
                                        className={"btn btn-"+colorIn}
                                        onClick={() => this.onClickChooseDealer(row)}
                                        disabled={boo}
                                    >
                                        Choose
                                    </button>
                                </td>
                                <td>{row.Fullname || "---"}</td>
                                <td>{row.Phone || "---"}</td>
                                <td>{row.Role || "---"}</td>
                                <td>{row.DealerName || "---"}</td>
                                <td>{row.WalletBalance || 0}</td>
                                <td style={{textAlign: "center"}}>{canBe(row.QualifyAgent)}</td>
                                <td style={{textAlign: "center"}}>{canBe(row.QualifyDealer)}</td>
                                <td>{row.Province || "---"}</td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
        )


    }
        newEntryFormOld=()=>{
        if(this.state.modeList){
            return null
        }

        let lsUser=[];
        for(let i in this.state.Information.Users){
            const row =this.state.Information.Users[i];
            lsUser.push(row);
        }

        const canBe=(boo)=>{
            if(boo){
                return "Yes"
            }
            return "No"
        }

        return(
            <div>
                <p className={"alert alert-info"}>Choose the user from the list to Upgrade</p>
            <table className={"table table-bordered"}>
                <thead className="table-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Full Name</th>
                        <th scope="col">AccountRef</th>
                        <th scope="col">Role</th>
                        <th scope="col">Dealer</th>
                        <th scope="col">Wallet</th>
                        <th scope="col">QualifyToBeAgent</th>
                        <th scope="col">QualifyToBeDealer</th>
                    </tr>
                </thead>
                <tbody>
                {lsUser.map((row,index)=>{
                    let boo = false;
                    if(!row.QualifyDealer){
                        boo=true;
                    }
                    return(
                        <tr key={index}>
                            <td>
                                <button
                                    className={"btn btn-default"}
                                    onClick={()=>this.onClickChooseDealer(row)}
                                    disabled={boo}
                                    >
                                    Choose
                                </button>
                            </td>
                            <td>{row.Fullname ||"---"}</td>
                            <td>{row.Phone ||"---"}</td>
                            <td>{row.Role||"---"}</td>
                            <td>{row.DealerName ||"---"}</td>
                            <td>{row.WalletBalance || 0}</td>
                            <td style={{textAlign:"center"}}>{canBe(row.QualifyAgent)}</td>
                            <td style={{textAlign:"center"}}>{canBe(row.QualifyDealer)}</td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
            </div>
        )


        let forms=[
            {name:"Ref",desc:"Main Reference",placeHolder:"e.g. 0729139504",type:"text",required:true},
            {name:"Email",desc:"Username Or Email",placeHolder:"e.g. info@home.com Or user2019",type:"text",required:true},
            {name:"Name",desc:"Full Name",placeHolder:"e.g. My Full name",type:"text",required:true},
            {name:"ContactPerson",desc:"Contact Person",placeHolder:"e.g. Mr. May2019",type:"text",required:true},
            {name:"ContactPhone",desc:"Contact Phone",placeHolder:"e.g. 0729139504",type:"text",required:true},
            {name:"ContactAddress",desc:"ContactAddress",placeHolder:"e.g. 05 addr line,city, provaince",type:"text",required:true},
            {name:"Province",desc:"Province",placeHolder:"e.g. Western Cape",type:"option",required:true,options:["Gauteng","Western Cape","Limpopo"]},
        ];

        const innerRender=(inObject,index)=>{
            let myReadOnly = false;
            if(this.state.modeUpdate){
                myReadOnly=true

            }

            if(inObject.type ==="option"){
                return(
                    <div className="form-group" key={index}>
                        <label htmlFor="exampleInputEmail1">{inObject.desc}</label>
                        <select
                            className="form-control"
                            id={inObject.name}
                            placeholder={inObject.placeHolder}
                            required={inObject.required}
                            value={this.getNewEntryValue(inObject.name)}
                            onChange={(e)=>this.setNewEntryValue(e,inObject.name)}
                            disabled={myReadOnly}
                        >
                            <option value={""}>---Select---</option>
                            {inObject.options.map((item)=>{
                                return(
                                    <option value={item}>{item}</option>
                                )
                            })}
                        </select>
                    </div>
                )
            }
            return(
                <div className="form-group" key={index}>
                    <label htmlFor="exampleInputEmail1">{inObject.desc}</label>
                    <input
                        type={inObject.type}
                        className="form-control"
                        id={inObject.name}
                        placeholder={inObject.placeHolder}
                        required={inObject.required}
                        value={this.getNewEntryValue(inObject.name)}
                        onChange={(e)=>this.setNewEntryValue(e,inObject.name)}
                        disabled={myReadOnly}
                    />
                </div>
            )
        }

        return(
            <div className="row">

                <div className="col-xs-12 col-lg-6">

                    {!this.state.modeUpdate?
                        <h3 className={"alert alert-info"}>New Dealer</h3>
                        :
                        <h3 className={"alert alert-danger"}>Update Dealer Info</h3>
                    }
                    <form onSubmit={this.submitEntry}>
                    {forms.map((row, index)=>{
                        return innerRender(row,index)
                    })}

                        {!this.state.modeUpdate ?
                            <button
                                className={"btn btn-primary pull-right"}
                                type={"submit"}
                            >Submit</button>
                            :
                            <button
                                className={"btn btn-danger pull-right"}
                                type={"button"}
                                onClick={()=>this.closeView()}
                            >Close</button>
                        }
                    </form>
                </div>
            </div>
        )
    }


    render() {

        return (


            <PageContentWallpaper {...this.props} >

                <div className="row">
                    <div className="col-xs-12">
                        <h2>Dealer Management
                            {!this.state.modeList?
                            <a className={"btn btn-danger pull-right"}
                               onClick={() => this.setState({modeList:true,modeUpdate:false})}>Cancel</a>
                                :
                                <a className={"btn btn-primary pull-right"}
                                   onClick={() => this.setState({modeList:false})}>New Dealer</a>
                            }
                        </h2>
                    </div>

                </div>

                {this.state.modeList?
                    <div className="row">
                        <div className="col-xs-12">

                            <table className="table">
                                <thead>
                                <tr>
                                    <th>Ref</th>
                                    <th>Full Name</th>
                                    <th>Email</th>
                                    <th>#</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.renderList()}
                                </tbody>
                            </table>

                        </div>
                    </div>:null}


                {this.newEntryForm()}

            </PageContentWallpaper>
        )


    }

}

const mapDispatchToProps = dispatch => ({
    dispatch: dispatch
})

const mapStateToProps = state => ({
    addingModel: state.addingModel,
    login: state.login
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingDealerComponent)